
import { Component, Input, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';


@Component({
  selector: 'atw-zalo-admin-follow',
  templateUrl: './zalo-follow-admin-button.component.html',
  styleUrls: ['./zalo-follow-admin-button.component.scss']
})
export class AtwZaloFollowAdminButton {
  @Input() data: any; // dữ liệu của object từ block truyền vào gồm {_id, component, desktop_position, mobile_position, x, y, rows, cols, z_index}
  isVisible = false; //Biến check ẩn hiện modal
  loading = false; //Biến check loading

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private message: NzMessageService
  ) { }

  ngOnInit() {
  }


  /**
   * Kiểm tra xem object đã tồn tại hay chưa, nếu chưa thì add, tồn tại rồi thì update
   * @param value 
   */
  updateOrAdd(value) {
    // Update
    this.vhQueryAutoWeb
      .updateSetup(this.data._id, value)
      .then(
        (bool: any) => {
          if (bool.vcode === 0) {
            this.createMessage('success', 'Cập nhật thành công');
          }
          else {
            this.createMessage('error', 'Cập nhật thất bại');
          }
        },
        (error) => {
          this.createMessage('error', 'Xảy ra lỗi trong quá trình cập nhật');
          console.log('error', error);
        }
      );
  }


  /**
   * Hàm hiển thị thông báo
   * @param type 
   * @param content 
   * @param duration 
   */
  createMessage(type: 'success' | 'error' | 'warning' | 'info', content: string, duration: number = 2000): void {
    this.message.create(type, content, {
      nzDuration: duration,
    });
  }


  showModal(): void {
    this.isVisible = true;
  }


  handleOk(): void {
    this.isVisible = false;
  }


  handleCancel(): void {
    this.isVisible = false;
  }

}
